import React from 'react';
import { Typography } from '@material-ui/core'

export default function HeadLine({ data, ...props }) {
    const propsWithoutData = {...props, data: null};
    return <Typography {...propsWithoutData}>{data}</Typography>
}